import { render, staticRenderFns } from "./GameStat.vue?vue&type=template&id=166b86ea&scoped=true&lang=pug&"
import script from "./GameStat.vue?vue&type=script&lang=ts&"
export * from "./GameStat.vue?vue&type=script&lang=ts&"
import style0 from "./GameStat.vue?vue&type=style&index=0&id=166b86ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b86ea",
  null
  
)

export default component.exports